import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import sellerOutboundReturnItemTableColumns from './seller-outbound-return-item-static-table-columns'
import DataStaticTable from 'components/organisms/data-table-static'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  showPagination : PropTypes.bool,
  rowButtonProps : PropTypes.object,
  hiddenColumns  : PropTypes.array
}

const defaultProps = {
  rowButtonProps: {}
}

/**
 * Domain-specific static datatable for Seller Outbound Return Item.
 * @param {array} data - Array of displated data
 * @param {array} pagination - Pagination
 * @param {array} showPagination - Flag to display/hide pagination
 * @param {array} hiddenColumns - Hidden Columns
 * @param {object} rowButtonProps - Button props for Action row button
 */
const SellerOutboundReturnItemStaticTable = ({
  data,
  pagination,
  showPagination,
  rowButtonProps,
  hiddenColumns
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const { buttonText, buttonColour, isButtonDisabled, onButtonClick } = rowButtonProps
  const columns                                                       = useMemo(
    () => sellerOutboundReturnItemTableColumns({
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    }),
    [
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    ]
  )

  return (
    <DataStaticTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      showPagination={ showPagination }
      hiddenColumns={ hiddenColumns }
    />
  )
}

SellerOutboundReturnItemStaticTable.propTypes    = propTypes
SellerOutboundReturnItemStaticTable.defaultProps = defaultProps

export default SellerOutboundReturnItemStaticTable
